import { Injectable } from '@angular/core';

import { GfTranslateService } from '../../../../services/core.translate.service';
import { FilterService } from '../../../../services/core.filter.service';

import * as _ from 'lodash';
import { DateGfUtcDatePipe } from '../../../../pipes/date/date.gf-utc-date.pipe';
import { marker } from '../../../../services/ngx-translate-extract-marker';

@Injectable()
export class ScmReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
        private filterService: FilterService,
    ) {
    }

    getOption(id, label, defaultSelected = false) {
        return { id: id, label: this.gfTranslateService.translate(label), defaultSelected: defaultSelected };
    }
    getAnyFilterObj() {
        return this.getOption('', marker('Any'), true);
    }
    getCustomFilterObj() {
        return this.getOption(null, marker('Custom'), false);
    }
    getYesNoElements() {
        return [
            this.getOption('N', marker('No'), true),
            this.getOption('Y', marker('Yes'), false)
        ];
    }
    getRangeDateElements() {
        // NOTE: Any is not the default for this filter.
        var any = this.getAnyFilterObj();
        any.defaultSelected = false;
        return [
            any,
            this.getOption('-7 days', marker("This Week"), true),
            this.getOption('-15 days', marker("Last 15 days")),
            this.getOption('-30 days', marker("Last 30 days")),
            this.getOption('-60 days', marker("Last 60 days")),
            this.getOption('-90 days', marker("Last 90 days")),
            this.getOption('-365 days', marker("Last year"))
        ];
    }
    getDefaultElement(list) {
        var defaults = _.find(list, { defaultSelected: true });
        return _.get(defaults, '[0]', null);
    }
    getBaseFilters() {

        var yesNoOptions = this.getYesNoElements();
        var rangeDateOptions = this.getRangeDateElements();

        return [
            {
                alias: "subprojects", fieldName: this.gfTranslateService.translate("Include Subprojects"),
                value: this.getDefaultElement(yesNoOptions),
                fieldType: 1, isExtraField: false, fieldElements: yesNoOptions
            },
            {
                alias: "details", fieldName: this.gfTranslateService.translate("Show Commits Table"),
                value: this.getDefaultElement(yesNoOptions),
                fieldType: 1, isExtraField: false, fieldElements: yesNoOptions
            },
            {
                alias: "rangeDate", fieldName: this.gfTranslateService.translate("Date Range"),
                value: this.getDefaultElement(rangeDateOptions),
                fieldType: 1, isExtraField: false, fieldElements: rangeDateOptions
            },
        ];
    }
    getSelectedElement(filter, stateParams) {
        var val = _.get(stateParams, filter.alias, false) || '';
        return _.find(filter.fieldElements, { id: val }) ||
            this.getDefaultElement(filter.fieldElements);
    }
    setFiltersFromStateParams(filters) { return this.filterService.setFilterValues(filters); }
    getCommitChartData(commitsData) {
        if (!commitsData) {
            return [];
        }

        var keyFormat = 'MMM DD';  // default
        if (commitsData.length > 240) {
            // MMM yy
            keyFormat = 'MMM YYYY';
        }

        const filter = new DateGfUtcDatePipe()

        var bins = _.reduce(
            commitsData,
            function (carry, item) {
                var key = filter.transform(item.commit_date, keyFormat);
                if (!_.has(carry, key)) {
                    carry[key] = { x: key, y: 0 };
                }
                carry[key].y += parseInt(item.quantity);
                return carry;
            },
            {}
        );

        return _.values(bins);
    }
    getTotal(values) {
        return values.reduce(
            function (carry, item) {
                return carry + item.y;
            },
            0
        );
    }
    getReduceXTicks(values) {
        return (this.getTotal(values) > 0 && values.length > 15);
    }
    getDateChartData(values) {
        return [
            {
                values: values,
                key: this.gfTranslateService.translate('Commits'),
                area: true
            }
        ];
    }
}